import React from 'react';
import { Header } from 'antd/es/layout/layout';
import BreadCrumb from './PageTitle';
import Avatar from './Avatar';
import { BellIcon } from 'assets/svg';
import { Space } from 'antd';
import Bell from './Bell';

const MainHeader = () => {
  return (
    <Header
      className="px-5 bg-white drop-shadow-md flex justify-end items-center"
      style={{ height: 50 }}
    >
      <Space>
        <Bell />
        <Avatar />
      </Space>
    </Header>
  );
};

export default MainHeader;
